import { FilterTreeNode, ResourceType } from "@/services/cloudchipr.api";
import { resourceTypeShortNames } from "@/utils/constants/resources/resourceTypeNames/resourceTypeShortNames";

export const generateResourceDetailsK8SResourceBillingDataPayload = (
  identifier: string[],
  resourceType: ResourceType,
): FilterTreeNode => ({
  node_type: "group",
  operator: "and",
  items: [
    {
      operator: "in",
      node_type: "item",
      value: [getFilterTypeFromResourceType(resourceType)],
      filter_provider: "kubernetes",
      type: "workload_type",
    },
    {
      operator: "in",
      node_type: "item",
      value: identifier,
      filter_provider: "kubernetes",
      type: "workload_name",
    },
  ],
});

const getFilterTypeFromResourceType = (resourceType: ResourceType) => {
  return (
    resourceTypeShortNames.get(resourceType)?.singular ??
    resourceType.replace("kubernetes_", "")
  );
};
